import React from 'react'
import { useSetRecoilState } from 'recoil'

import {
  ABTEST_STATUS_CONFIGURATION,
  ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
  ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED,
  ABTEST_STATUS_PRE_ENQUEUING,
  ABTEST_STATUS_ENQUEUING,
  ABTEST_STATUS_POST_ENQUEUING,
  ABTEST_STATUS_SCHEDULING,
  ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES,
  ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
  ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED,
  ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
  ABTEST_STATUS_COMPLETED,
  ABTEST_STATUS_STOP_DURING_TEST,
  ABTEST_STATUS_STOP_DURING_WINNER
} from 'Api/beABTestApi'
import { Actions } from 'mailup-web-components'
import evalCondition from 'Helpers/evalCondition'
import { notifyParent } from 'Helpers/notifyParent'
import {
  modalDeleteState,
  modalRecoverState
} from 'Pages/AbTestList/recoil/state/results'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'

const ActionsMenu = ({ info, aggregateReport, count, recoverable }) => {
  const intl = useIntl()
  const setModalDeleteState = useSetRecoilState(modalDeleteState)
  const setModalRecoverState = useSetRecoilState(modalRecoverState)
  const history = useHistory()

  const handleEdit = () => {
    history.push('/messages/email/abtest/' + info.ABTestID)
  }

  const handleManage = () => {
    history.push(`/messages/email/abtestmanage/${info.ABTestID}`)
  }

  const handleStats = () => {
    notifyParent('redirectMainFrame', [
      `/console/statistics_app_redirector.aspx?r=/stats/insight/aggregate/view/${aggregateReport.AggregateReportId}`
    ])
  }

  const handleRecoverChange = value => {
    setModalRecoverState(prev => ({
      ...prev,
      show: true,
      state: info.Stato,
      name: info.Nome,
      idABTest: info.ABTestID
    }))
  }

  const handleDeleteChange = value => {
    setModalDeleteState(prev => ({
      ...prev,
      show: true,
      state: info.Stato,
      name: info.Nome,
      idABTest: info.ABTestID
    }))
  }

  const menuActions = []

  if (
    [
      ABTEST_STATUS_CONFIGURATION,
      ABTEST_STATUS_PRE_ENQUEUING,
      ABTEST_STATUS_ENQUEUING,
      ABTEST_STATUS_POST_ENQUEUING,
      ABTEST_STATUS_SCHEDULING
    ].includes(info.Stato) &&
    count === 0
  ) {
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.MailupCommon.Edit' }),
      separator: false,
      onClick: handleEdit,
      'data-mu-test': 'action-edit'
    })
  }

  if (
    [
      ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES,
      ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
      ABTEST_STATUS_WINNER_MESSAGE_DEFINED,
      ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED,
      ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED,
      ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED,
      ABTEST_STATUS_COMPLETED,
      ABTEST_STATUS_STOP_DURING_TEST,
      ABTEST_STATUS_STOP_DURING_WINNER
    ].includes(info.Stato) &&
    count === 0
  ) {
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.MailupCommon.Manage' }),
      separator: false,
      onClick: handleManage,
      'data-mu-test': 'action-manage'
    })
  }

  if (evalCondition('uo:STAT') && aggregateReport) {
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.AbTest.ShowDetailedStatistics' }),
      separator: false,
      onClick: handleStats,
      'data-mu-test': 'action-show-detailed-statistics'
    })
  }

  if (recoverable && count === 0) {
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.AbTest.Recover' }),
      separator: false,
      onClick: () => {
        handleRecoverChange()
      },
      'data-mu-test': 'action-recover'
    })
  }

  if (
    ![
      ABTEST_STATUS_PRE_ENQUEUING,
      ABTEST_STATUS_ENQUEUING,
      ABTEST_STATUS_POST_ENQUEUING,
      ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED,
      ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED
    ].includes(info.Stato)
  ) {
    menuActions.push({
      label: intl.formatMessage({ id: 'Load.MailupCommon.Delete' }),
      separator: false,
      onClick: () => {
        handleDeleteChange()
      },
      'data-mu-test': 'action-delete'
    })
  }

  return <Actions items={menuActions} />
}

export default ActionsMenu
